<template>
    <v-dialog
        v-model="showDialog"
        width="800"
        style="z-index: 250"
    >
        <v-card v-if="data && data.ACU_MEMBERS && Array.isArray(data.ACU_MEMBERS)" class="no-shadow">
            <v-toolbar
                dense
                color="teal"
                dark
                class="no-shadow"
            >
                <v-toolbar-title class="toolbar-title">
                    Member{{ data.ACU_MEMBERS.length > 1 ? 's' : '' }} included on Letter: <v-chip small>
                        ID: {{ data.ID }}
                    </v-chip>&nbsp;
                    <v-tooltip v-if="isOverflowing" top open-delay="300">
                        <template #activator="{ on, attrs }">
                            <span
                                ref="accountText"
                                class="ellipsis-text"
                                v-bind="attrs"
                                v-on="on"
                            >
                                {{ data.ACU_ACCOUNT }}
                            </span>
                        </template>
                        <span>{{ data.ACU_ACCOUNT }}</span>
                    </v-tooltip>
                    <span
                        v-else
                        ref="accountText"
                        class="ellipsis-text"
                    >
                        {{ data.ACU_ACCOUNT }}
                    </span>
                </v-toolbar-title>
                <v-spacer />
                <v-tooltip top open-delay="300">
                    <template #activator="{ on, attrs }">
                        <v-btn 
                            icon 
                            v-bind="attrs" 
                            v-on="on"
                            @click="showDialog = false"    
                        >
                            <v-icon>{{ mdiClose }}</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </v-toolbar>
        </v-card>
        <v-data-table
            ref="dataTableLetterMembers"
            :fixed-header="true"
            :items="rows"
            class="letterMembersTbl"
            :items-per-page.sync="itemsPerPage"
            :headers="headers"
            :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000, -1],
                'items-per-page-text': ''
            }"
            :search="search.value"
        >
            <template #top>
                <v-text-field
                    v-model="search.query"
                    outlined
                    style="width: 100%;"
                    placeholder="Search ..."
                    hide-details
                    dense
                    clearable
                    :append-icon="mdiMagnify"
                    color="teal"
                    @click:clear="search.value = null"
                    @keydown.enter.prevent="search.value = search.query"
                    @click:append="search.value = search.query"
                />
            </template>
            <template #body="{ items }">
                <tbody>
                    <tr v-for="(item, rowIndex) in items" :key="rowIndex">
                        <td
                            v-for="header in headers"
                            :key="header.value"
                            style="text-align: center"
                        >
                            <template v-if="header.value === 'ACTIONS'">
                                <v-tooltip top>
                                    <template #activator="{ on }">
                                        <v-btn
                                            icon
                                            color="error"
                                            :disabled="items && items.length < 2 && search.value == null"
                                            v-on="on"
                                            @click="showDeleteMember(item)"
                                        >
                                            <v-icon>{{ mdiTrashCan }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Remove Member</span>
                                </v-tooltip>
                            </template>
                            <template v-else>
                                {{ item[header.value] }}
                            </template>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
        <ConfirmDeleteMember
            :show="showDelete.show"
            :data="showDelete.data"
            :notif="notif"
            :require-pdf-update="requirePdfUpdate"
            @closeDialog="showDelete.show = false"
        />
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ConfirmDeleteMember from './ConfirmDeleteMember.vue'
import {
    mdiClose,
    mdiMagnify,
    mdiTrashCan
} from '@mdi/js'
export default {
    components: { ConfirmDeleteMember },
    props: ['show', 'data', 'notif', 'requirePdfUpdate'],
    data: () => ({
        mdiClose,
        mdiMagnify,
        mdiTrashCan,
        isOverflowing: false,
        headers: [
            { text: 'Member No.', value: 'MEMB_N', align: 'center' },
            { text: 'Member Name', value: 'LAST_M', align: 'center' },
            { text: 'Actions', value: 'ACTIONS', sortable: false, align: 'center' }
        ],
        itemsPerPage: 10,
        pageNumber: 1,
        search: {
            value: null,
            query: null
        },
        showDelete: {
            data: null,
            show: false
        },
        rows: []
    }),
    computed: {
        ...mapGetters(['deleteMemberFromEndorsementConfirmationData']),
        showDialog: {
            get() {
                if (this.show) this.$nextTick(this.checkOverflow)
                return this.show
            },
            set() {
                this.resetSearch()
                this.$emit('closeDialog')
            }
        }
    },
    watch : {
        'data.ACU_ACCOUNT'() {
            this.$nextTick(this.checkOverflow)
        },
        deleteMemberFromEndorsementConfirmationData(newVal) {
            if (newVal && newVal.status === 200) {
                const index = this.rows.findIndex(
                    item => item.MEMB_N === this.showDelete.data.MEMB_N
                )
                if (index !== -1) {
                    this.rows.splice(index, 1)
                }
            }
        },
        'data.ACU_MEMBERS'(newVal) {
            if (newVal) {
                console.log('changed')
                this.rows = [...newVal]
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.checkOverflow)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkOverflow)
    },
    methods: {
        checkOverflow() {
            const el = this.$refs.accountText
            if (!el) return
            this.isOverflowing = el.scrollWidth > el.clientWidth
        },
        resetSearch() {
            this.search = { value: null, query: null }
        },
        showDeleteMember(item) {
            this.showDelete.show = !this.showDelete.show
            this.showDelete.data = item
        }
    }
}
</script>

<style>
.letterMembersTbl .v-data-table__wrapper {
    overflow-y: auto;
    max-height: 70vh;
}

.no-shadow {
    background-color: red;
  box-shadow: none !important;
}


.ellipsis-text {
  display: inline-block;
  max-width: 380px; /* adjust as needed */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.ellipsis-text {
  cursor: default;
}
.ellipsis-text.truncated {
  cursor: help;
}



</style>
